module.exports = __webpack_public_path__ + "static/media/p4.623f2e44.png";